import {Banner} from "../../components/main/Banner";
import {Content1} from "../../components/main/Content1";
import {Content2} from "../../components/main/Content2";
import {Content3} from "../../components/main/Content3";
import {Content5} from "../../components/main/Content5";
import {Content4} from "../../components/main/Content4";
import {Content6} from "../../components/main/Content6";
import {BaseLayout} from "../../layouts/Base";
import {ScrollTop} from "../../components/ScrollTop";

export const HomePage = () => {

    return (
        <BaseLayout>
            <ScrollTop/>
            <Banner/>
            <Content1/>
            <Content2/>
            <Content5/>
            <Content4/>
            <Content3/>
            <Content6/>
        </BaseLayout>
    )
}